import { render, staticRenderFns } from "./report-entity-search-result-template.vue?vue&type=template&id=1353dd44&"
import script from "./report-entity-search-result-template.vue?vue&type=script&lang=ts&"
export * from "./report-entity-search-result-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports